import React from 'react';
import PropTypes from 'prop-types';

import Widget from '../widgets/widget';

const styles = {
  reportUnavailableContainer: {
    margin: '10px',
  },
};

function WidgetContainer(props) {
  const {
    selectedReport, selectedLocation, inApp, reportDataId, location, gridColumn,
  } = props;

  if (!selectedReport || !selectedLocation) {
    return null;
  }

  const isReportAvailable = !(location && !location.reportAssignments.map(ra => ra.reportId).includes(selectedReport.reportID));

  if (!isReportAvailable) {
    return (
      <div style={{ ...styles.reportUnavailableContainer, gridColumn }}>
        Bericht für dieses Lokal nicht verfügbar
      </div>
    );
  }

  if (!selectedReport.reportItems) {
    return null;
  }

  return selectedReport.reportItems.map((widget, i) => (
    <Widget
      key={`widget_${widget.reportWidgetID}`}
      locationID={selectedLocation.id}
      inApp={inApp}
      {...widget}
      reportDataId={reportDataId}
      gridColumn={gridColumn}
      gridRow={i + 2}
    />
  ));
}

WidgetContainer.propTypes = {
  selectedReport: PropTypes.object,
  selectedLocation: PropTypes.object,
  loadingReports: PropTypes.array,
  useDesktopLayout: PropTypes.bool,
  inApp: PropTypes.bool,
  reportDataId: PropTypes.number,
  location: PropTypes.object,
};

WidgetContainer.defaultProps = {
  selectedReport: null,
  selectedLocation: null,
  loadingReports: [],
  useDesktopLayout: false,
  inApp: false,
  reportDataId: null,
  location: null,
};

export default WidgetContainer;
